import styled, { css } from 'styled-components';
import { Wrapper } from 'AppReact';
import { colorShade } from 'utils';

const template = styled.tr`
  ${({ displayState }) => css`
    height: 54px;
    box-shadow: ${displayState?.isSelected ? '0px 0px 9px 0px rgba(0, 0, 0, 0.09)' : ''};
    td {
      border-right: ${displayState?.isSelected ? '' : '1px solid #E7EBEB'};
      border-bottom: 1px solid #E7EBEB;
      padding: 0px;
      cursor: pointer;
    }

    th {
      border-right: ${displayState?.isSelected ? '' : '1px solid #E7EBEB'};
      border-bottom: 1px solid #E7EBEB;
      background-color: ${displayState?.isSelected ? '#FFFFFF' : '#FCFCFC'};
      white-space: nowrap;
      cursor: pointer;

      &:hover {
        background-color: ${colorShade(0.9, window?.settings?.primary_color ?? '#1DBD6B')};
        border-right: none;
        transition: background-color .3s;
      }
    }

    td:nth-child(2) {
      background-color: #FCFCFC;
      border-right: none;
      /* &:hover {
        background-color: #F4FCF8;
      } */
    }
    td:nth-child(3) {
      background-color: ${displayState?.isSelected ? '#FFFFFF' : '#FCFCFC'};
      border-right: none;
      ${!displayState?.disabledReadyDate && css`
        &:hover {
          background-color: ${colorShade(0.9, window?.settings?.primary_color ?? '#1DBD6B')};
        }
      `}
    }
    td:nth-child(4) {
      background-color: #FCFCFC;
      /* &:hover {
        background-color: #F4FCF8;
      } */
    }


    th:hover ~ td:nth-child(2) {
      background-color: ${colorShade(0.9, window?.settings?.primary_color ?? '#1DBD6B')};
    }
    th:hover ~ td:nth-child(3) {
      background-color: ${colorShade(0.9, window?.settings?.primary_color ?? '#1DBD6B')};
    }
    th:hover ~ td:nth-child(4) {
      background-color: ${colorShade(0.9, window?.settings?.primary_color ?? '#1DBD6B')};
    }

    &:first-child {
      td {
        border-top: 1px solid #E7EBEB;
      }
      th {
        border-top: 1px solid #E7EBEB;
      }
    }
  `}
`;

export default Wrapper(template)